import Route from '@ember/routing/route';

class PrivacyPolicyRoute extends Route {
  redirect(_, transition) {
    transition.abort;
    window.location.replace('/legal/privacy-policy/');
  }
}

export default PrivacyPolicyRoute;
